// store/slices/meterResetSlice.js
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/AxiosInstance";

export const fetchLastReadingThunk = createAsyncThunk(
  "meterReset/fetchLast",
  async (home_id, { rejectWithValue }) => {
    try {
      const res = await api.get(`/api/meter-reset/house/${home_id}`);
      if (!res.data?.success) return rejectWithValue(res.data?.message);
      return res.data.data;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

export const resetMeterThunk = createAsyncThunk(
  "meterReset/reset",
  async ({ home_id, new_reading }, { rejectWithValue }) => {
    try {
      const res = await api.post(`/api/meter-reset/reset/${home_id}`, {
        new_reading,
      });
      if (!res.data?.success) return rejectWithValue(res.data?.message);
      return true;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

const slice = createSlice({
  name: "meterReset",
  initialState: {
    lastReading: null,
    loading: false,
    saving: false,
    error: null,
  },
  reducers: {
    clearMeterResetError: (s) => {
      s.error = null;
    },
  },
  extraReducers: (b) => {
    b.addCase(fetchLastReadingThunk.pending, (s) => {
      s.loading = true;
    });
    b.addCase(fetchLastReadingThunk.fulfilled, (s, a) => {
      s.loading = false;
      s.lastReading = a.payload;
    });
    b.addCase(fetchLastReadingThunk.rejected, (s, a) => {
      s.loading = false;
      s.error = a.payload;
    });

    b.addCase(resetMeterThunk.pending, (s) => {
      s.saving = true;
    });
    b.addCase(resetMeterThunk.fulfilled, (s) => {
      s.saving = false;
    });
    b.addCase(resetMeterThunk.rejected, (s, a) => {
      s.saving = false;
      s.error = a.payload;
    });
  },
});

export const { clearMeterResetError } = slice.actions;
export default slice.reducer;
